import BigThreeElements from './BigThreeElements';
import EightIndicators from './EightIndicators';
import Intro from './Intro';
import ScoreCard from './ScoreCard';
import WhyFocus from './WhyFocus';
import Responses from './Responses';
import { PREVIOUS_STAGE_KEY } from 'utils/app-constants';
import localStorage from 'utils/localStorage';
import Auth from 'shared/Auth';

export const CDRComponentMap = [{
    component: Responses,
    label: true,
    transaltionRef: 'StageOneLabel',
    name: 'Stage I Responses',
  }, {
    component: Intro,
    route: '5b7a91a6ff26',
    label: false,
    transaltionRef: '0',
    name: 'Why Capacity Diagnostic Report',
  }, {
    component: WhyFocus,
    route: 'why-focus',
    label: false,
    transaltionRef: '1',
    name: 'Why Focus on Organisational Capacity',
  }, {
    component: EightIndicators,
    route: 'how-you-performed',
    label: false,
    transaltionRef: '2',
    name: 'How You Performed',
  }, {
    component: BigThreeElements,
    route: 'big-three-elements',
    label: false,
    transaltionRef: '3',
    name: "Our “big 3” Capacity Elements",
  }, {
    component: ScoreCard,
    route: 'score-card',
    label: false,
    transaltionRef: '4',
    name: 'Score Card Questions',
  }, {
    component: Responses,
    route: localStorage.getItem(PREVIOUS_STAGE_KEY),
    label: false,
    transaltionRef: '5',
    name: 'CDR Question Responses'
  }
];



// WEBPACK FOOTER //
// ./src/components/CDRSections/CDRComponentMap.js